import { createServerFn } from "@tanstack/react-start";

import { isViewStateStoreConfigured } from "@/lib/core/view-state-store.server.ts";

export const getKitsViewStateAvailable = createServerFn({
    method: "GET",
}).handler(() => isViewStateStoreConfigured());
